export default "__VITE_ASSET__DgYXqLlE__"